// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2qNxZ","rootSmall":"AddTileButton_rootSmall__7Gf1i"};